// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"153":"f1952d88","697":"35d611c3","823":"e3bd6e2a","936":"98291f05","965":"2c1dc3b8"}[chunkId] + ".chunk.js";
};